import axios from 'axios'
import React, { FC, useEffect, useState } from 'react'
import avarter from '../../../../../Assets/images/user-empty-avatar.png'
import './imageUpload.scss'
interface dataTypes {
  register: any;
  values:any;
}

const ImageUploader: FC<dataTypes> = ({ register, values }) => {
  const [photo, setPhoto] = useState<any>(null)

  const handleFileUpload = async (event: { target: any }) => {
    console.log(event.target.files[0])
    console.log(event.target.files[0].name)
    setPhoto(URL.createObjectURL(event.target.files[0]))

    const dataFileUp = {
      document: event.target.files[0],
      nin: values.nin,
      documentType: 'photo'
    }

    await fileUploader(dataFileUp)

    const formData = new FormData()

    // Update the formData object
    formData.append(
      'file',
      event.target.files[0]
    )

    console.log('formData', formData)
  }

  useEffect(() => {
    setPhoto(avarter)
  }, [])

  const fileUploader = async (data:{document:any, nin:number, documentType:string}) => {
    const headers = {
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json'
    }
    await axios.post(`${process.env.REACT_APP_URL}/admission/upload-credentials`, data, {
      headers
    })
      .then(async (res) => {
        console.log('UPLOAD COMPLETED', res)
      }, (error) => {
        console.log('FILE UPLOAD ERROR', error.response)
      })
  }

  return (
        <div className='imageUploader'>
            <form>
                <div className='row h-100'>
                    <div className="col-md-6 my-auto justify-content-center text-center">
                        {!values?.photo
                          ? <React.Fragment>
                            <div className='fotoContainer mt-5'>
                              <img src={photo} alt="" className="pfoto w-25"/>
                               <input
                                type="file"
                                accept="image/*"
                                id="contained-button-file"
                                className='d-none'
                                onChange={handleFileUpload}
                              />
                              <div className='uploadAction'>
                                <label htmlFor="contained-button-file">
                                  <i className='fa fa-plus'></i>
                                </label>
                              </div>

                        </div>
                       </React.Fragment>
                          : <React.Fragment>
                         <img src={`data:image/png;base64, ${values.photo}`} className="w-25 rounded shadow"></img>
                    </React.Fragment>}

                    </div>
                    <div className="col-md-6 my-auto text-center">
                        <h2 className='fw-bolder'>{values.surname} {values.firstname} {values.middlename} </h2>
                        <h4 className=''>NIN: {values.nin}</h4>
                    </div>
                </div>
            </form>
        </div>
  )
}
export default ImageUploader
